import React from "react";
import { LogIn } from "react-feather";
import { useAuth } from 'Utils/Hooks/useAuth';
import { useNavigate } from "react-router-dom";
// import profile from "assets/images/dashboard/profile.png";
import { LI, UL, Image, P } from "Core/Components";

const UserHeader = () => {
  const history = useNavigate();
  const { currentAdmin } = useAuth();

  const Logout = () => {
    history(`${process.env.PUBLIC_URL}/logout`);
  };

  // const UserMenuRedirect = (redirect) => {
  //   history(redirect);
  // };

  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <div className="media profile-media">
        <Image
          attrImage={{
            className: "b-r-10 m-0",
            // src: `${currentAdmin.profile !== undefined ? currentAdmin.profile : profile}`,
            src: ``,
            alt: "",
          }}
        />
        <div className="media-body">
          <span>{currentAdmin && currentAdmin?.email}</span>
          <P attrPara={{ className: "mb-0 font-roboto" }}>
            {currentAdmin?.user_type} <i className="middle fa fa-angle-down"></i>
          </P>
        </div>
      </div>
      <UL attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}>
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>{"LogOut"}</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
